import { ISSUE } from "../_constants/actionConstants";

const issueInitialState = {
  issueList: {}, // Normalized by issueId, shallow-mapped issueDtos for list only
  openIssues: {}, // Normalized by tabId
  fetching: false,
  error: null
};

export const reducer = (state = issueInitialState, action) => {
  switch (action.type) {
    case ISSUE.FETCH_ALL_ISSUES:
    case ISSUE.FETCH_ISSUE:
    case ISSUE.ADD_ISSUE:
    case ISSUE.FOLLOW_ISSUE:
    case ISSUE.UNFOLLOW_ISSUE:
    case ISSUE.UPDATE_ISSUE:
    case ISSUE.ADD_POST:
    case ISSUE.LIKE_POST:
      return { ...state, fetching: true };

    case ISSUE.FETCH_ISSUE_FULFILLED:
    case ISSUE.ADD_ISSUE_FULFILLED:
    case ISSUE.FOLLOW_ISSUE_FULFILLED:
    case ISSUE.UNFOLLOW_ISSUE_FULFILLED:
    case ISSUE.UPDATE_ISSUE_FULFILLED:
    case ISSUE.ADD_POST_FULFILLED:
    case ISSUE.LIKE_POST_FULFILLED: {
      // Update the list. Swap only the updated item.
      const issueList = {
        ...state.issueList,
        [action.issue.issueId]: action.issue
      };

      // Update any openIssues. If none found, and if new issue is provided,
      // add to openIssues. If neither are applicable, default to
      // existing state.openIssues.
      const openIssues = { ...state.openIssues }; // The default

      // If new, add...else find any matching openIssues to update
      if (action.tabId && !(action.tabId in openIssues))
        openIssues[action.tabId] = action.issue;
      else {
        for (const tabId in openIssues) {
          // If there is a matching openIssue, replace it with the new one.
          if (openIssues[tabId].issueId === action.issue.issueId)
            openIssues[tabId] = action.issue;
        }
      }

      return { ...state, issueList, openIssues, fetching: false };
    }

    case ISSUE.FETCH_ALL_ISSUES_FULFILLED: {
      const issueList = {};
      action.issueList.forEach(i => (issueList[i.issueId] = i));
      return { ...state, issueList, fetching: false };
    }

    case ISSUE.FETCH_ALL_ISSUES_REJECTED:
    case ISSUE.FETCH_ISSUE_REJECTED:
    case ISSUE.ADD_ISSUE_REJECTED:
    case ISSUE.FOLLOW_ISSUE_REJECTED:
    case ISSUE.UNFOLLOW_ISSUE_REJECTED:
    case ISSUE.UPDATE_ISSUE_REJECTED:
    case ISSUE.ADD_POST_REJECTED:
    case ISSUE.LIKE_POST_REJECTED:
      return { ...state, fetching: false, error: action.payload };

    case ISSUE.CLOSE_ISSUE_TAB: {
      const openIssues = { ...state.openIssues };
      delete openIssues[action.tabId];
      return { ...state, openIssues, fetching: false };
    }
    default:
      return state;
  }
};
